import React from 'react';

export type InfoBoxProp = {
    text: string;
};

export const InfoBox: React.FC<InfoBoxProp> = ({ text }) => {
    return <p className="c-info-box"> {text} </p>;
};
